import React, {ReactElement, useMemo, useState} from 'react';

import {useAshDisposalCalculator} from '../../decision/ashDisposalCalculator';
import {StorageCropId} from '../../decision/data/storageAshTransport';
import {buildSimpleCalculatorTableRow, buildStorageCropIdRow} from '../../util/calculators.util';
import Select from '../Select';
import SimpleCalculatorCard from './SimpleCalculatorCard';
import SimpleCalculatorTable, {SimpleCalculatorTableCell} from './SimpleCalculatorTable';
import ValueWithUnit from './ValueWithUnit';

type Props = {};

const fuelCombustedOptions = [10, 50, 100, 500, 1000, 25000].map(tonnage => ({
  label: `${tonnage} tonnes`,
  value: tonnage,
}));

const AshDisposalCalculator = ({}: Props): ReactElement => {
  const [fuelCombusted, setFuelCombusted] = useState<number>();
  const [cropId, setCropId] = useState<StorageCropId>();

  const input = {fuelCombusted, cropId};
  const {data} = useAshDisposalCalculator(input);

  const fuelCombustedLabel = fuelCombusted !== undefined ? `${fuelCombusted} tonnes` : 'Select';

  const values = useMemo<SimpleCalculatorTableCell[][]>(
    () => [
      buildSimpleCalculatorTableRow({
        leftContent: 'Annual Tonnage of Fuel Combusted',
        rightContent: (
          <Select
            floating
            variant={'table'}
            buttonContent={fuelCombustedLabel}
            options={fuelCombustedOptions}
            selectedValues={fuelCombusted ? [fuelCombusted] : []}
            onOptionSelected={value => setFuelCombusted(value)}
            buttonClassName={'rounded-r-2xl'}
          />
        ),
        border: 'both',
        type: 'input',
      }),
      buildStorageCropIdRow({cropId, onSelected: setCropId}),
      buildSimpleCalculatorTableRow({
        leftContent: 'Ash content',
        rightContent: <ValueWithUnit value={data?.crop?.ash} unit={'%'} />,
        border: 'bottom',
      }),
      buildSimpleCalculatorTableRow({
        leftContent: 'Annual Production of ash to be disposed of',
        rightContent: <ValueWithUnit value={data?.annualAsh} unit={'tonnes'} />,
      }),
    ],
    [fuelCombustedLabel, fuelCombusted, cropId, data?.crop?.ash, data?.annualAsh]
  );

  return (
    <SimpleCalculatorCard title={'Ash Disposal'}>
      <SimpleCalculatorTable values={values} />
    </SimpleCalculatorCard>
  );
};

export default AshDisposalCalculator;
